import React, { useState } from 'react';
import { acceptInvite } from '../api/rolesApi';
import { Button } from '../components/UI';

const AcceptInvitePage = ({ token }) => {
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleAccept = async () => {
    setStatus('loading');
    try {
      await acceptInvite(token);
      setStatus('success');
      // Close WebApp after short delay
      setTimeout(() => {
        window.Telegram?.WebApp?.close();
      }, 2500);
    } catch (err) {
      setErrorMsg(err.message || 'Произошла ошибка');
      setStatus('error');
    }
  };

  // ── Success ──
  if (status === 'success') {
    return (
      <div style={{
        minHeight: '100vh', background: '#f8fafc',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: 32, textAlign: 'center', gap: 20,
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: '#dcfce7',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          animation: 'popIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#111827', margin: '0 0 8px' }}>
            Вы успешно присоединились!
          </h1>
          <p style={{ fontSize: 14, color: '#6b7280', margin: 0 }}>
            Роль добавлена. Окно закроется автоматически...
          </p>
        </div>
        <style>{`@keyframes popIn { from { transform: scale(0.5); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>
      </div>
    );
  }

  // ── Error ──
  if (status === 'error') {
    const isExpired = errorMsg.toLowerCase().includes('expired') || errorMsg.toLowerCase().includes('истек');
    const isExhausted = errorMsg.toLowerCase().includes('limit') || errorMsg.toLowerCase().includes('лимит');
    const isAlreadyHas = errorMsg.toLowerCase().includes('already') || errorMsg.toLowerCase().includes('уже');

    return (
      <div style={{
        minHeight: '100vh', background: '#f8fafc',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: 32, textAlign: 'center', gap: 20,
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: '#fee2e2',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </div>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 800, color: '#111827', margin: '0 0 8px' }}>
            {isExpired ? 'Ссылка устарела' : isExhausted ? 'Лимит исчерпан' : isAlreadyHas ? 'Роль уже назначена' : 'Ошибка'}
          </h1>
          <p style={{ fontSize: 14, color: '#6b7280', margin: 0, lineHeight: 1.5 }}>
            {isExpired
              ? 'Срок действия этой ссылки истёк. Попросите организатора сгенерировать новую.'
              : isExhausted
              ? 'По этой ссылке уже нельзя присоединиться — лимит использований исчерпан.'
              : isAlreadyHas
              ? 'У вас уже есть эта роль на данном событии.'
              : errorMsg}
          </p>
        </div>
        <Button variant="secondary" onClick={() => window.Telegram?.WebApp?.close()}>
          Закрыть
        </Button>
      </div>
    );
  }

  // ── Idle / Loading ──
  return (
    <div style={{
      minHeight: '100vh', background: '#f8fafc',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: 32, textAlign: 'center', gap: 24,
    }}>
      {/* Icon */}
      <div style={{
        width: 80, height: 80, borderRadius: '50%',
        background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 8px 24px rgba(99,102,241,0.35)',
      }}>
        <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </div>

      <div>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#111827', margin: '0 0 10px' }}>
          Приглашение
        </h1>
        <p style={{ fontSize: 15, color: '#374151', margin: '0 0 6px', lineHeight: 1.5 }}>
          Вас пригласили присоединиться к событию.
        </p>
        <p style={{ fontSize: 13, color: '#6b7280', margin: 0 }}>
          После принятия вам будет назначена роль участника.
        </p>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <Button
          onClick={handleAccept}
          loading={status === 'loading'}
          fullWidth
        >
          Принять приглашение
        </Button>
        <Button
          variant="secondary"
          onClick={() => window.Telegram?.WebApp?.close()}
          fullWidth
        >
          Отклонить
        </Button>
      </div>
    </div>
  );
};

export default AcceptInvitePage;